import organizationIconSvg from './assets/organization-icon.svg';
import React, { Component } from 'react';

const ORGANIZATION_TYPE_TEXT = {
  sports: {
    title: 'Sports Orgs',
    text: [
      'Post in minutes / Get applications same day',
      'Automated Emergency Action Plans for every job posted',
      'Electronic injury documentation included with HIPAA compliant record storage',
    ],
  },
  school: {
    title: 'Schools',
    text: [
      'Post in minutes / Get applications same day',
      'From one game or practice to long term coverage',
      'Flexible payments options',
    ],
  },
  medical: {
    title: 'Hospitals and Clinics',
    text: [
      'Post in minutes / Get applications same day',
      'Expand community outreach with a flexible workforce',
      'Drive new patient referrals with HIPAA compliant injury documentation',
    ],
  },
  industrial: {
    title: 'Companies',
    text: [
      'Post in minutes / Get applications same day',
      'Compliance driven staffing from a single location to multiple ATs across several locations',
      'Flexible payments options',
    ],
  },
  facility: {
    title: 'Sports Facilities',
    text: [
      'Certified and insured athletic trainers',
      'HIPAA compliant injury documentation and storage included',
      'Manage multiple events, ATs and financial reporting from a single dashboard',
    ],
  },
  performing_arts: {
    title: 'Performing Arts',
    text: [
      'Post in minutes / Get applications same day',
      'Performance ready care for rehearsal, shows and tours ',
      'Flexible payment options',
    ],
  },
  other: {
    title: 'Organizations',
    text: [
      'Largest, nationwide network of athletic trainers',
      'Post in minutes / Get applications same day',
      'Per diem and long term coverage',
      'No listing fees',
    ],
  },
  athleticTrainer: {
    title: 'Athletic Trainers',
    text: [
      'Highest paying jobs for ATs',
      'Guaranteed payment',
      'Sideline EMR included',
      'Exclusive access to the only AT Professional Liability + General Liability combo policy',
    ],
  },
};

export default class OrganizationTypeSection extends Component {
  render() {
    const { orgType } = this.props;
    const organizationText = ORGANIZATION_TYPE_TEXT[orgType] || ORGANIZATION_TYPE_TEXT.other;
    return (
      <div className="organization-section">
        Why {organizationText.title} use Go4 {orgType === 'industrial' && 'to staff ATs'}
        {organizationText.text.map((line, index) => (
          <div className="org-text" key={index}>
            <img src={organizationIconSvg} alt="orgIcon" />
            <p key={index}>{line}</p>
          </div>
        ))}
      </div>
    );
  }
}
